module.exports = __webpack_public_path__ + "img/IMAGE 7.5da72638.png";